import React from 'react'
import PropTypes from 'prop-types'

import { MediaContainer, HeroImage, HeroVideo } from './styles'

export default function MediaBlock({ resourceUrl, altText, isVideo }) {
  return (
    <MediaContainer>
      {isVideo ? (
        <HeroVideo src={resourceUrl} alt={altText} controls autoPlay muted loop preload="auto" />
      ) : (
        <HeroImage src={resourceUrl} alt={altText} />
      )}
    </MediaContainer>
  )
}

MediaBlock.propTypes = {
  resourceUrl: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  isVideo: PropTypes.bool.isRequired,
}
